module.exports = __webpack_public_path__ + "img/assault_railgun.d9b0de56.jpg";